import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

class PasswordRequestLinks extends React.PureComponent {
	render() {
		const { translations } = this.props;

		return (
			<div className="login-links">
				<Link to={"/reviewer/login"}>
					{translations.sections.reviewer_password_request.back_link}
				</Link>
				<Link to={"/reviewer/register"}>
					{translations.sections.reviewer_password_request.contact_button}
				</Link>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations
	};
};

export default connect(mapStateToProps)(PasswordRequestLinks);



// WEBPACK FOOTER //
// ./src/components/reviewer/password-request/PasswordRequestLinks.js